export default "__VITE_ASSET__DTL2POXE__"